import { Html, Line } from '@react-three/drei';
import * as THREE from 'three';

import { UnitSystem } from '../../../types/util.ts';
import { getLengthUnitLabel, toDisplayLength } from '../../../utils/unitSystem.ts';

interface DistanceLineProps {
  isSelected?: boolean;
  start: THREE.Vector3;
  end: THREE.Vector3;
  distance: number;
  unitSystem: UnitSystem;
}

export const DistanceLine = ({ isSelected, start, end, distance, unitSystem }: DistanceLineProps) => {
  const displayDistance = toDisplayLength(distance, unitSystem);
  const lengthUnitLabel = getLengthUnitLabel(unitSystem);

  return (
    <group>
      <Line points={[start, end]} lineWidth={1} dashed dashSize={0.1} gapSize={0.1} />
      {isSelected && (
        <Html position={[start.x + 0.5, start.y, (start.z + end.z) / 2]} zIndexRange={[10, 0]}>
          <div
            style={{
              background: 'rgba(0, 0, 0, 0.7)',
              padding: '4px 8px',
              borderRadius: '4px',
              color: '#B3EC49',
              fontSize: '12px',
              whiteSpace: 'nowrap',
              pointerEvents: 'none',
            }}
          >
            Height: {displayDistance.toFixed(2)} {lengthUnitLabel}
          </div>
        </Html>
      )}
    </group>
  );
};
